import "./css/output.css";
export default function PointValue({ label, value, className, ...props }) {
  const computedClassName = ["output", "point-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && (
        <>
          <strong>{label}</strong>&nbsp;
        </>
      )}
      <span>
        &#10629;{value?.coordinates?.[0]},&nbsp;{value?.coordinates?.[1]}
        &#10630;
      </span>
    </div>
  );
}

PointValue.defaultProps = {
  className: "",
};
